// extracted by mini-css-extract-plugin
export default {"container":"Stats_container__Jpx36","title":"Stats_title__wjqSg","month":"Stats_month__ZB4zM","result":"Stats_result__rhPjr","details":"Stats_details__EB10A"};